import styled from 'styled-components';

export const Container = styled.div`
  z-index: 1;
  height: 100vh;
  .openmenu {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    cursor: pointer;
  }

  .open {
    position: fixed;
    width: 250px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
    min-height: 100vh;
    background: #007bff;
    padding: 16px;
    color: #fff;
    animation: slideInLeft 200ms linear;
  }
  .footer {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .closed {
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
    min-height: 100vh;
    background: #007bff;
    padding: 16px;
    top: 0;
  }

  .logout {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    p {
      margin: 8px;
      color: #fff;
    }
  }

  @keyframes slideInLeft {
    0% {
      transform: translateX(-70%);
      visibility: visible;
    }
    100% {
      transform: translateX(0);
    }
  }
`;
